import { ThemeProvider, createTheme } from "@mui/material";
import { createContext, useContext, useEffect, useMemo, useState } from "react";

const ColorModeContext = createContext({ mode: "light", toggleMode: () => {} });
export const useColorMode = () => useContext(ColorModeContext);

export function AppThemeProvider({ children }) {
  const [mode, setMode] = useState(
    localStorage.getItem("color-mode") || "light"
    // localStorage.getItem("color-mode") || (window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light")
  );

  // Update body attribute for SCSS variables
  useEffect(() => {
    document.body.setAttribute("data-theme", mode);
    document.body.style.backgroundColor = mode === "dark" ? "#121212" : "#fff";
  }, [mode]);

  const colorMode = useMemo(
    () => ({
      mode,
      toggleMode: () => {
        setMode((prev) => {
          const next = prev === "light" ? "dark" : "light";
          localStorage.setItem("color-mode", next);
          return next;
        });
      },
    }),
    [mode]
  );

  const theme = useMemo(
    () =>
      createTheme({
        palette: {
          mode,
          ...(mode === "light"
            ? { background: { default: "#fff", paper: "#fff" } }
            : { background: { default: "#121212", paper: "#1e1e1e" } }),
        },
      }),
    [mode]
  );

  return (
    <ColorModeContext.Provider value={colorMode}>
      <ThemeProvider theme={theme}>{children}</ThemeProvider>
    </ColorModeContext.Provider>
  );
}
